var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLoginSso(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 68,
    viewBox: "0 0 47 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4998 49.0514V56.0169M40.7887 65.0177H6.21115C4.43766 65.0177 3 63.58 3 61.8064V31.8937C3 30.1201 4.43766 28.6824 6.21115 28.6824H40.7887C42.5623 28.6824 44 30.1201 44 31.8937V61.8064C44 63.58 42.5623 65.0177 40.7887 65.0177ZM10.1001 28.3787V16.4513C10.1001 9.05327 16.1531 3 23.5514 3C30.9497 3 37.0029 9.05327 37.0029 16.4513V28.3787H10.1001ZM29.8334 46.2565C29.8334 43.3109 26.4454 37.923 23.4998 37.923C20.5544 37.923 18.1664 40.3109 18.1664 43.2565C18.1664 46.2021 20.5544 48.5898 23.4998 48.5898C26.4454 48.5898 29.8334 49.2021 29.8334 46.2565Z",
    stroke: "white",
    strokeWidth: 4.8957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginSso);
export default __webpack_public_path__ + "static/media/Icon_Login_SSO.a32f5f53a7964b93300dc35a2ccb680a.svg";
export { ForwardRef as ReactComponent };